import Pusher from 'pusher-js'
import repository from '@/repositories/repository'

let pusher = null

export default function getWebSocket() {
    const key = process.env.VUE_APP_WS_APP_KEY

    if (!key) {
        return null
    }

    if (pusher === null) {
        const apiUrl = new URL(process.env.VUE_APP_ROOT_API, window.location.origin)
        const forceTLS = apiUrl.protocol === 'https:'

        pusher = new Pusher(key, {
            wsHost: process.env.VUE_APP_WS_HOST || apiUrl.hostname,
            wsPort: Number(process.env.VUE_APP_WS_PORT || 6001),
            wssPort: Number(process.env.VUE_APP_WS_PORT || 443),
            forceTLS,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
            authorizer: channel => ({
                authorize: (socketId, callback) => {
                    repository.post('/api/broadcasting/auth', {
                        socket_id: socketId,
                        channel_name: channel.name,
                    })
                        .then(({data}) => callback(null, data))
                        .catch(error => callback(error, null))
                },
            }),
        })
    }

    return pusher
}
